export default {
    methods: {
        openLoading() {
            const loading = this.$loading({ // 声明一个loading对象
                lock: true, // 是否锁屏
                fullScreen: true, //是否为全屏 Dialog
                background: "rgba(255,255,255,0.7)" //遮罩背景色
            })
            setTimeout(function() { // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
                loading.close(); // 关闭遮罩层
            }, 5000)
            return loading;
        },
    }
}



// WEBPACK FOOTER //
// ./src/mixin/mixin.js